module.exports = __webpack_public_path__ + "img/niva-avatar.bd6f3216.png";